//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectFaceList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CalculationType",1,0],[0,"CuttingPerimeter",1,0],[0,"DecimalPlaces",1,0],[1,"ForceProcess",0,"SelectFaceList",0],[0,"GravityCenter",1,0],[0,"HoldingForce",1,0],[0,"Parameter",1,0],[0,"ParameterText",1,0],[1,"ProcessFace",0,"ScCollector",0],[0,"ProcessForce",1,0],[0,"ProcessName",1,0],[0,"ProcessType",1,0],[0,"TotalForce",1,0],[0,"TotalForceCenter",1,0]],[[["strings","radPattern"],"CalculateForce",{R_:{newStrings:""}},2,0],[["object","attr_name","attr_value"],"AssignAttribute",{},3,0]],[]];
SPLM.Tooling.ForceCalculationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ForceCalculationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ForceCalculationBuilder.ProcessTypes = Object.freeze({
    "Catalog" : "Catalog", "AngularBlanking" : "AngularBlanking", "AngularEmbossing" : "AngularEmbossing", "AngularPiercing" : "AngularPiercing", "Bending" : "Bending", "Blanking" : "Blanking", "Burring" : "Burring", "CircularDrawing" : "CircularDrawing", "Counterboring" : "Counterboring", "Countersinking" : "Countersinking", "CylindricalIroning" : "CylindricalIroning", "Flanging" : "Flanging", "Piercing" : "Piercing", "RoundEmbossing" : "RoundEmbossing", "SquareDrawing" : "SquareDrawing", "UBending" : "UBending", "VBending" : "VBending", "VBendingTree" : "VBendingTree", "ZBending" : "ZBending"});

SPLM.Tooling.ForceCalculationBuilder.CalculationTypes = Object.freeze({
    "Normal" : "Normal", "Isolated" : "Isolated"});

export default SPLM;